import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsPageTitleStyles {
    container?: GridContainerProps;
    titleText?: TypographyProps;
    freeSwagText?: TypographyProps;
    discountedShippingText?: TypographyProps;
    defaultButtonGridItem?: GridItemProps;
}

export const pageTitleStyles: ProductDetailsPageTitleStyles = {
    container: {
        gap: 0,
        offsetCss: css`
            max-width: 100%;
            margin-bottom: 15px;
        `,
    },
    defaultButtonGridItem: {
        width: 12,
        css: css`
            font-size: 16px;
            font-weight: 600;
        `,
    },
    titleText: {
        variant: "h2",
    },
    freeSwagText: {
        css: css`
            color: ${getColor("secondary")};
            width: 100%;
            margin-top: 5px;
            text-transform: uppercase;
        `,
    },
    discountedShippingText: {
        css: css`
            color: red;
            width: 100%;
            text-transform: uppercase;
        `,
    },
};

const styles = pageTitleStyles;

const ShippingAndSwagFlags: React.FC<Props> = () => {
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.defaultButtonGridItem}>
                <Typography {...styles.discountedShippingText} data-test-selector="productDetails_action_add_to_cart">
                    {translate("Discounted Shipping $150+")}
                </Typography>
            </GridItem>
            <GridItem {...styles.defaultButtonGridItem}>
                <Typography {...styles.freeSwagText} data-test-selector="productDetails_action_free_swag">
                    {translate("Free Swag $150+")}
                </Typography>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ShippingAndSwagFlags),
    definition: {
        displayName: "Shipping and Swag Flags",
        group: "Custom" as any,
        allowedContexts: ["ProductDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
